import cssUtil from 'gw-portals-util-js/CssUtil';
import styles from './content-tile-hashed.scss';
import template from 'text!../templates/generic-tile.html';

export default [function () {
    return {
        restrict: 'E',
        replace: true,
        scope: {
            flavor: '@'
        },
        transclude: {
            'header': '?gwTileHeader',
            'actions': '?gwTileAction',
            'content': 'gwTileContent'
        },
        template: cssUtil.hashTemplate(template, styles),
        controller: ['$scope', 'tiles.tilesUtilFunctions', function ($scope, tilesUtilFunctions) {
            $scope.tileType = 'content';
            $scope.customFlavor = $scope.flavor || 'default';
            $scope.allow = {
                header: true,
                content: true,
                actions: true,
                footer: false
            };

            // Callback is a nop in the content tile
            $scope.clickCallback = function () {
                return true;
            };
            $scope.getActiveState = function () {
                return '';
            };
            $scope.getStyle = tilesUtilFunctions.getStyleFunction(styles);
        }]
    };
}];


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/platform/widgets/tiles/Content/ContentTile.js
// module id = 1159
// module chunks = 0